module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__wrap--bg cmp-modal",
    class: {
      'is-active': _vm.annPreViewModal
    },
    attrs: {
      "id": "ann-view-template"
    }
  }, [_c('div', {
    staticClass: "modal-wrap-container modal-wd1020"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body-container ht-full mt-40 sticky"
  }, [_c('div', {
    staticClass: "box-community-top box-type"
  }, [_c('div', {
    staticClass: "job-title-info"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.result.ANN_NM))]), _vm._v(" "), _c('div', {
    staticClass: "description mt-16"
  }, [_vm._v(_vm._s(_vm.result.INTRO))])])]), _vm._v(" "), _c('div', {
    staticClass: "cont-section mt-0"
  }, [_c('div', {
    staticClass: "h3-title font-bold mt-40"
  }, [_vm._v("기본정보")]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("기본정보 표")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("업직종")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.OCCUPATION_LABEL))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("모집대상")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.RCRT_SE_NM))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("모집인원")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.RCRT_PPL) + "명")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("모집기간")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.APPDURNG_ST) + " " + _vm._s(_vm.result.APPDURNG_ST_TM) + "시 ~ " + _vm._s(_vm.result.APPDURNG_ED) + " " + _vm._s(_vm.result.APPDURNG_ED_TM) + "시")])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("합격자 발표일")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.PASS_DAY))])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.TEL_1) + " - " + _vm._s(_vm.result.TEL_2) + " - " + _vm._s(_vm.result.TEL_3))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont-section mt-0"
  }, [_c('div', {
    staticClass: "h3-title font-bold mt-40"
  }, [_vm._v("활동조건")]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("활동조건 표")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("나이")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.AGE) + "~" + _vm._s(_vm.result.AGE_TO) + " " + _vm._s(_vm.result.AGE_DESC))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("거주지")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.RESIDENCE))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("경력사항")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.CAREER_HISTORY_LABEL))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("필수역량")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.REQ_COMPETENCE))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("우대조건")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.PREF_CONDITIONS))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont-section mt-0"
  }, [_c('div', {
    staticClass: "h3-title font-bold mt-40"
  }, [_vm._v("직무정보")]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("직무정보 표")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("직무명")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.JOB_NAME))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("담당업무")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.DUTIES))])]), _vm._v(" "), _c('tr', [_vm._m(8), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.occupationAndPosition))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont-section mt-0"
  }, [_c('div', {
    staticClass: "h3-title font-bold mt-40"
  }, [_vm._v("활동환경")]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("활동환경 표")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("시급")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.payCondition) + "원")])]), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.PAY_CONDITION))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("활동기간")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.actperPeriod))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("근무형태")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.WORK_CONDITION_LABEL))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("활동처")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.LOCATION))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont-section mt-0"
  }, [_c('div', {
    staticClass: "h3-title font-bold mt-40"
  }, [_vm._v("협력기관(기업) 정보")]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("협력기관(기업) 정보 표")]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(14), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.CORPR_ORG))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("소개")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.PARTNER_INTRO))])]), _vm._v(" "), _c('tr', [_vm._m(15), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.PARTNER_FEATURE))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("주요 사업")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.PARTNER_BUSINESS))])]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("주소")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.PARTNER_POST)), _c('br'), _vm._v(_vm._s(_vm.result.PARTNER_ADDR1)), _c('br'), _vm._v(_vm._s(_vm.result.PARTNER_ADDR2))])]), _vm._v(" "), _c('tr', [_vm._m(16), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.PARTNER_MANAGER))])]), _vm._v(" "), _c('tr', [_vm._m(17), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.PARTNER_TEL))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "cont-section mt-0"
  }, [_c('div', {
    staticClass: "h3-title font-bold mt-40"
  }, [_vm._v("공고 내용")]), _vm._v(" "), _c('div', {
    staticClass: "table-wrap"
  }, [_c('table', {
    staticClass: "table-body-only"
  }, [_c('caption', [_vm._v("공고 내용 표")]), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('div', {
    staticClass: "editor-content-area mt-0",
    domProps: {
      "innerHTML": _vm._s(_vm.result.ANN_DTL_DESC)
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(20), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.result.KWD))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary btn-md button-wid150",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        닫기\n      ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-close only-icon",
    attrs: {
      "type": "button",
      "aria-label": "닫기",
      "title": "닫기"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "ico ico-x-bl"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("공고 미리보기")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("문의 "), _c('br', {
    staticClass: "mo-only"
  }), _vm._v("연락처")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("소속 및"), _c('br', {
    staticClass: "mo-only"
  }), _vm._v(" 직책")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("급여조건 "), _c('br', {
    staticClass: "mo-only"
  }), _vm._v(" 추가 "), _c('br', {
    staticClass: "mo-only"
  }), _vm._v("설명")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("협력 "), _c('br', {
    staticClass: "mo-only"
  }), _vm._v("기관명")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("조직구성 "), _c('br', {
    staticClass: "mo-only"
  }), _vm._v("및 특징")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("협력기관 "), _c('br', {
    staticClass: "mo-only"
  }), _vm._v("담당자")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("협력기관"), _c('br', {
    staticClass: "mo-only"
  }), _vm._v(" 연락처")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "pc-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "160px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('colgroup', {
    staticClass: "mo-cell"
  }, [_c('col', {
    staticStyle: {
      "width": "88px"
    }
  }), _vm._v(" "), _c('col')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("연관 "), _c('br', {
    staticClass: "mo-only"
  }), _vm._v("키워드")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9305db6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/components/AnnPreView.vue
// module id = 1537
// module chunks = 6